<div class="featured-menu-items">
    <div class="title-container">
        <h3 class="title">{{menu.title}}</h3>
        <finder-icon-tooltip *ngIf="tooltip"
            class="tooltip"
            [id]="tooltip.id"
            [name]="tooltip.name"
            [title]="menu.title"
            [size]="tooltip.size"
            [tooltip]="tooltip.text"
            [position]="tooltip.position">
        </finder-icon-tooltip>
    </div>
    <div class="meal-periods-container" *ngIf="mealPeriods">
        <finder-breadcrumb class="breadcrumb"
            *ngFor="let period of mealPeriods"
            [links]="period.breadcrumb"
            [breadcrumb]="period.breadcrumbTemplate">
        </finder-breadcrumb>
    </div>
    <div class="menu-items-container" *ngIf="menuItems">
        <div class="menu-item" *ngFor="let picture of menuItems">
            <finder-picture class="image" [picture]="picture"></finder-picture>
            <div class="captions">{{picture.title}}</div>
        </div>
    </div>
</div>
